module.exports = __webpack_public_path__ + "img/favicon.ffe973a8.svg";